import { Button, Modal } from "antd";
import { useEffect, useState } from "react";
import type { EventOccasion } from "../../../../shared/types/event.types";
import EventOccasionDndOrder from "./EventOccasionDndOrder";

interface EventOccasionOrderModalProps {
	isOpen: boolean;
	onClose: () => void;
	title?: string;
	eventOccasions: EventOccasion[];
	onUpdateOrder: (occasions: EventOccasion[]) => Promise<void>;
	primaryColor?: string;
	primaryLightColor?: string;
}

const EventOccasionOrderModal = ({
	isOpen,
	onClose,
	title,
	eventOccasions: initialOccasions,
	onUpdateOrder,
	primaryColor = "#1890ff",
	primaryLightColor = "#e6f7ff",
}: EventOccasionOrderModalProps) => {
	const [occasions, setOccasions] = useState<EventOccasion[]>([]);

	useEffect(() => {
		if (isOpen && occasions.length === 0) {
			// Sort initial occasions by displayOrder before showing
			const sorted = [...initialOccasions].sort(
				(a, b) => (a.displayOrder ?? 0) - (b.displayOrder ?? 0),
			);
			setOccasions(sorted);
		} else if (!isOpen && occasions.length > 0) {
			setOccasions([]);
		}
	}, [isOpen, initialOccasions, occasions.length]);

	const handleSave = async () => {
		await onUpdateOrder(occasions);
		onClose();
	};

	const handleUndo = () => {
		const sorted = [...initialOccasions].sort(
			(a, b) => (a.displayOrder ?? 0) - (b.displayOrder ?? 0),
		);
		setOccasions(sorted);
	};

	return (
		<Modal
			open={isOpen}
			onCancel={onClose}
			title={title || "イベント表示順編集"}
			footer={null}
			destroyOnClose
			maskClosable={false}
			centered
			width={720}
			styles={{
				body: {
					maxHeight: "80vh",
					overflowY: "auto",
					overflowX: "hidden",
					padding: "24px",
				},
			}}
		>
			<div className="flex justify-end mb-6 gap-2">
				<Button danger size="large" onClick={handleUndo} className="px-8">
					元に戻す
				</Button>
				<Button
					type="primary"
					size="large"
					onClick={handleSave}
					className="px-8"
					style={{ backgroundColor: primaryColor }}
				>
					保存
				</Button>
			</div>

			<div
				className="flex justify-center rounded mb-8 p-4 text-center"
				style={{
					color: primaryColor,
					backgroundColor: primaryLightColor,
					border: `1px solid ${primaryColor}`,
				}}
			>
				<p className="m-0">イベントを上下にドラッグして並べ替えます</p>
			</div>

			<EventOccasionDndOrder
				eventOccasions={occasions}
				setEventOccasions={setOccasions}
				primaryColor={primaryColor}
				primaryLightColor={primaryLightColor}
			/>
		</Modal>
	);
};

export default EventOccasionOrderModal;
